export const messages = {
  en: {
    reserveServiceManage: {
      searchCondition: 'Search Condition',
      goodsIdPlaceholder: 'Please enter service ID',
      goodsNamePlaceholder: 'Please enter service name',
      statePlaceholder: 'Please select status',
      stateOffShelf: 'Off Shelf',
      stateOnShelf: 'On Shelf',
      reserveService: 'Reserve Service',
      addService: 'Add Service',
      serviceCover: 'Service Cover',
      nameAndId: 'Name(ID)',
      params: 'Parameters',
      reserveWay: 'Reserve Way',
      day: 'Day',
      week: 'Week',
      reserveCount: 'Reserve Count',
      reserveQuantity: 'Reserve Quantity',
      doorFee: 'Door Fee',
      validity: 'Validity',
      reserveStartTime: 'Reserve Start Time',
      sort: 'Sort',
      state: 'Status',
      offShelf: 'Off Shelf',
      onShelf: 'On Shelf',
      addCatalog: 'Add Catalog',
      addCatalogFirst: 'Please add catalog first'
    },
    addReserveServicePerson: {
      reserveService: 'Reserve Service',
      personName: 'Reserve Person',
      personNamePlaceholder: 'Required, please enter reserve person',
      personTel: 'Reserve Tel',
      personTelPlaceholder: 'Required, please enter reserve tel',
      payWay: 'Payment Way',
      payWayPlaceholder: 'Please select payment way',
      cash: 'Cash',
      wechat: 'WeChat',
      alipay: 'Alipay',
      receivableAmount: 'Receivable Amount',
      receivableAmountPlaceholder: 'Required, please enter receivable amount',
      receivedAmount: 'Received Amount',
      receivedAmountPlaceholder: 'Required, please enter received amount',
      appointmentTime: 'Appointment Time',
      appointmentTimePlaceholder: 'Required, please select appointment time',
      openTime: 'Open Time',
      openTimePlaceholder: 'Required, please select open time',
      hour: ' o\'clock',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please enter remark',
      personNameRequired: 'Reserve person is required',
      personNameMaxLength: 'Reserve person cannot exceed 64 characters',
      personTelRequired: 'Reserve tel is required',
      personTelMaxLength: 'Reserve tel cannot exceed 11 characters',
      appointmentTimeRequired: 'Appointment time is required',
      receivableAmountRequired: 'Receivable amount is required',
      receivedAmountRequired: 'Received amount is required',
      payWayRequired: 'Payment way is required',
      remarkRequired: 'Remark is required',
      openTimeRequired: 'Open time is required'
    },
    deleteReserveDining: {
      confirmTitle: 'Please confirm your operation!',
      confirmContent: 'Confirm to delete reserve service'
    }
  },
  zh: {
    reserveServiceManage: {
      searchCondition: '查询条件',
      goodsIdPlaceholder: '请输入服务ID',
      goodsNamePlaceholder: '请输入服务名称',
      statePlaceholder: '请选择状态',
      stateOffShelf: '未上架',
      stateOnShelf: '上架',
      reserveService: '预约服务',
      addService: '添加服务',
      serviceCover: '服务封面',
      nameAndId: '名称(编号)',
      params: '参数',
      reserveWay: '预约方式',
      day: '日',
      week: '周',
      reserveCount: '预约次数',
      reserveQuantity: '预约数量',
      doorFee: '上门费',
      validity: '有效期',
      reserveStartTime: '开始预约时间',
      sort: '排序',
      state: '状态',
      offShelf: '未上架',
      onShelf: '上架',
      addCatalog: '添加目录',
      addCatalogFirst: '请先添加目录'
    },
    addReserveServicePerson: {
      reserveService: '预约服务',
      personName: '预约人',
      personNamePlaceholder: '必填，请填写预约人',
      personTel: '预约电话',
      personTelPlaceholder: '必填，请填写预约电话',
      payWay: '支付方式',
      payWayPlaceholder: '请选择支付方式',
      cash: '现金',
      wechat: '微信',
      alipay: '支付宝',
      receivableAmount: '应收金额',
      receivableAmountPlaceholder: '必填，请填写应收金额',
      receivedAmount: '实收金额',
      receivedAmountPlaceholder: '必填，请填写实收金额',
      appointmentTime: '预约日期',
      appointmentTimePlaceholder: '必填，请选择预约日期',
      openTime: '预约时间',
      openTimePlaceholder: '必填，请选择预约时间',
      hour: '时',
      remark: '备注',
      remarkPlaceholder: '必填，请填写备注',
      personNameRequired: '预约人不能为空',
      personNameMaxLength: '预约人不能超过64个字符',
      personTelRequired: '预约电话不能为空',
      personTelMaxLength: '预约电话不能超过11个字符',
      appointmentTimeRequired: '预约时间不能为空',
      receivableAmountRequired: '应收金额不能为空',
      receivedAmountRequired: '实收金额不能为空',
      payWayRequired: '支付方式不能为空',
      remarkRequired: '备注不能为空',
      openTimeRequired: '预约时间不能为空'
    },
    deleteReserveDining: {
      confirmTitle: '请确认您的操作!',
      confirmContent: '确定删除预约服务'
    }
  }
}